import { theme } from "../../../foundations/theme.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { BorderRadius } from "../../../foundations/border-radius.es.js";
const BlockNoticeTitleContainer = styled("div", styledOptions)(({
  isMobile
}) => ({
  display: Displaying.flex,
  alignItems: Alignment.center,
  gap: Spacing["500"],
  padding: isMobile ? Spacing["1000"] : `${Spacing["1000"]} ${Spacing["1500"]}`,
  borderBottomLeftRadius: BorderRadius.brand,
  borderBottomRightRadius: BorderRadius.brand,
  "&.primary.high": {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  "&.primary.light": {
    background: theme.palette.primary.light,
    color: theme.palette.primary.dark
  },
  "&.warning.high": {
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText
  },
  "&.warning.light": {
    background: theme.palette.warning.light,
    color: theme.palette.warning.dark
  }
}));
export {
  BlockNoticeTitleContainer
};
//# sourceMappingURL=block-notice-title-container.es.js.map
